export class Tarea{
	constructor(
		public id: number,
		public categoria: string,
		public id_usuario: number,
		public color: string,
		public cliente: number
	){}
}

export class NewTask{
	constructor(
		public id: number,
		public titulo: string,
		public tipo: number,
		public hora_inicio: string,
		public hora_termino: string,
		public fecha_inicio: string,
		public fecha_termino: string,
		public comentario: string,
		public importancia: number,
		public estatus: number,
		public privado: boolean,
		public usuarios: Array<any>,
		public color: string,
	){}
}
export class VerTask{
	constructor(
		public actividad: string,
		public color: string,
		public comentarios: string,
		public date: string,
		public date2: string,
		public estatus: string,
		public fecha: string,
		public fecha2:  string,
		public id_estatus: number,
		public id_tarea: number,
		public importancia: string,
		public importancia_color: string,
		public nombre: string,
		public num_importancia: number,
		public privada: number,
		public tipo_fecha: number
	){}
}
export class DelTask{
	constructor(
		public tarea:number,
		public id_us:number
	){}
}
export class VerCalendario{
	constructor(
		public tarea:number,
		public id_us:number,
		public tipo:number
	){}
}

export class EstatusAdministrar{
	constructor(
		public id_estatus,
		public estatus
	){}
}